import { defineStore } from 'pinia';

interface State {
  isOpenMobileMenu: boolean
  isShowDetailsUpdatedModal: boolean
  isShowDefaultCreditReportFailedModal: boolean
  isShowCreditReportMatchFailModal: boolean
  isShowErrorScreen: boolean
  isShowInternalServerErrorPopup: boolean
}

export default defineStore('main', {
  state: (): State => ({
    isOpenMobileMenu: false,
    isShowDetailsUpdatedModal: false,
    isShowDefaultCreditReportFailedModal: false,
    isShowCreditReportMatchFailModal: false,
    isShowErrorScreen: false,
    isShowInternalServerErrorPopup: false,
  }),
  actions: {
    toggleHeaderMenu(): void {
      this.isOpenMobileMenu = !this.isOpenMobileMenu;
    },
  },
});
